import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ValidationTextFields from './ValidationTextFields';
import ClientProvider from './client';
export default createDemo(import.meta.url, ValidationTextFields, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/validation/ValidationTextFields.tsx",
    "fileName": "ValidationTextFields.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\n\nexport default function ValidationTextFields() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <div>\n        <TextField\n          error\n          id=\"outlined-error\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n        />\n        <TextField\n          error\n          id=\"outlined-error-helper-text\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          helperText=\"Incorrect entry.\"\n        />\n      </div>\n      <div>\n        <TextField\n          error\n          id=\"filled-error\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          variant=\"filled\"\n        />\n        <TextField\n          error\n          id=\"filled-error-helper-text\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          helperText=\"Incorrect entry.\"\n          variant=\"filled\"\n        />\n      </div>\n      <div>\n        <TextField\n          error\n          id=\"standard-error\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          variant=\"standard\"\n        />\n        <TextField\n          error\n          id=\"standard-error-helper-text\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          helperText=\"Incorrect entry.\"\n          variant=\"standard\"\n        />\n      </div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 63,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport TextField from '@mui/material/TextField';\n\nexport default function ValidationTextFields() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <div>\n        <TextField\n          error\n          id=\"outlined-error\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n        />\n        <TextField\n          error\n          id=\"outlined-error-helper-text\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          helperText=\"Incorrect entry.\"\n        />\n      </div>\n      <div>\n        <TextField\n          error\n          id=\"filled-error\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          variant=\"filled\"\n        />\n        <TextField\n          error\n          id=\"filled-error-helper-text\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          helperText=\"Incorrect entry.\"\n          variant=\"filled\"\n        />\n      </div>\n      <div>\n        <TextField\n          error\n          id=\"standard-error\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          variant=\"standard\"\n        />\n        <TextField\n          error\n          id=\"standard-error-helper-text\"\n          label=\"Error\"\n          defaultValue=\"Hello World\"\n          helperText=\"Incorrect entry.\"\n          variant=\"standard\"\n        />\n      </div>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 63,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/TextField"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
